import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './wrappers/ErrorBoundary';
import ThemeWrapper from './wrappers/ThemeWrapper';
import AppWithRouteAccess from './AppWithRouteAccess';
import { CssBaseline } from '@mui/material';
import properties from './core-utils/properties';

const App: React.FC = () => {
  return (
    <React.StrictMode>
      <ThemeWrapper>
        <>
          <CssBaseline />
          <ErrorBoundary>
            <BrowserRouter basename={properties.PUBLIC_URL}>
              <React.Suspense fallback={<div />}>
                <AppWithRouteAccess />
              </React.Suspense>
            </BrowserRouter>
          </ErrorBoundary>
        </>
      </ThemeWrapper>
    </React.StrictMode>
  );
};

export default App;
